// Shared small UI helpers
import React from "react";

export const StatusBadge = ({ status, kind = "status" }) => (
  <span data-testid={`badge-${kind}-${status}`} className={`inline-block px-2 py-0.5 text-[10px] uppercase tracking-[0.12em] font-semibold ${kind}-${status}`}>
    {String(status || "").replace("_", " ")}
  </span>
);

export const DataLabel = ({ children, className = "" }) => (
  <div className={`data-label ${className}`}>{children}</div>
);

export const DataValue = ({ children, className = "" }) => (
  <div className={`data-value ${className}`}>{children}</div>
);

export const daysUntil = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  const now = new Date();
  return Math.ceil((d - now) / (1000 * 60 * 60 * 24));
};

export const urgencyClass = (days) => {
  if (days == null) return "urgency-ok";
  if (days <= 7) return "urgency-7";
  if (days <= 15) return "urgency-15";
  if (days <= 30) return "urgency-30";
  return "urgency-ok";
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};
